module.exports = __webpack_public_path__ + "static/media/logo-mobile.b2450a0e.svg";